import React, { useReducer, useContext } from 'react';
import firebase from 'firebase';

import { firestoreInitialize } from 'config/firebase/client';

import AlliesContext from './AlliesContext';
import AlliesReducer from './AlliesReducer';
import AuthenticationContext from 'context/Authentication/AuthenticationContext';

const AlliesState = (props) => {
    const initialState = {
        getAllies: {
            allies: [],
            firstAlly: null,
            lastAlly: null,
            nextAllies: null,
            alliesFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getAlliesAllMonth: {
            allies: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getAlliesById: {
            ally: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateAlliesById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getTypesAllies: {
            types: [],
            firstType: null,
            lastType: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        createAlliesTypes: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        deleteAlliesTypes: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        verifyAlly: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateCommissionsAlly: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        getAlliesExcel: {
            allies: [],
            alliesFilter: [],
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
    }

    const { authenticatedState } = useContext(AuthenticationContext)

    const [state, dispatch] = useReducer(AlliesReducer, initialState);

    const getAllies = (nextPage, prevPage, notPagination, country) => {
        dispatch({ type: 'GET_ALLIES_LOADING' });

        if (country) {
            getAlliesPerCountry(nextPage, prevPage, notPagination, country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAllies(nextPage, prevPage, notPagination);
        } else {
            getAlliesPerCountry(nextPage, prevPage, notPagination, authenticatedState.user.pais);
        }
    };

    const getGlobalAllies = (nextPage, prevPage, notPagination) => {
        let db = firestoreInitialize();
        
        if (notPagination) {
            let first = db.collection("Aliados")

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else if (nextPage) {
            let first = db.collection("Aliados")
                .orderBy('aliadoId')
                .startAfter(nextPage)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Aliados")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else if (prevPage) {
            let first = db.collection("Aliados")
                .orderBy('aliadoId')
                .endBefore(prevPage)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Aliados")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else {
            let first = db.collection("Aliados")
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Aliados")
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        }
    }

    const getAlliesPerCountry = (nextPage, prevPage, notPagination, country) => {
        let db = firestoreInitialize();
        
        if (notPagination) {
            let first = db.collection("Aliados")
                .where('pais', '==', country)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
            })
            .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else if (nextPage) {
            db.collection("Aliados")
                .where('aliadoId', '==', nextPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Aliados")
                    .where('pais', '==', country)
                    .startAfter(querySnapshot.docs[0])
                    .limit(10)
    
                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];
    
                            let nextDocument = db.collection("Aliados")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else if (prevPage) {
            db.collection("Aliados")
                .where('aliadoId', '==', prevPage)
                .limit(1)
                .get().then((querySnapshot) => {

                    let first = db.collection("Aliados")
                    .where('pais', '==', country)
                    .endBefore(querySnapshot.docs[0])

                    first.get().then((documentSnapshots) => {
                        if (documentSnapshots.size < 10) {
                            dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                        } else {
                            const data = documentSnapshots.docs.map(doc => doc.data());
                            const first = documentSnapshots.docs[documentSnapshots.docs.length=data.length-10];
                            const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                            let nextDocument = db.collection("Aliados")
                                .where('pais', '==', country)
                                .startAfter(last)
                                .limit(1)
                                
                            nextDocument.get().then((documentSnapshots) => {
                                const length = data.length - 10;

                                data.splice(0, length);

                                if (documentSnapshots.size === 1) {
                                    dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                                } else {
                                    dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                                }
                            });
                        }
                    })
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        } else {
            let first = db.collection("Aliados")
                .where('pais', '==', country)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    if (documentSnapshots.size < 10) {
                        dispatch({ type: 'GET_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]}, next: false });
                    } else {
                        const data = documentSnapshots.docs.map(doc => doc.data());
                        const first = documentSnapshots.docs[documentSnapshots.docs.length=0];
                        const last = documentSnapshots.docs[documentSnapshots.docs.length-1];

                        let nextDocument = db.collection("Aliados")
                            .where('pais', '==', country)
                            .startAfter(last)
                            .limit(1)
                            
                        nextDocument.get().then((documentSnapshots) => {
                            if (documentSnapshots.size === 1) {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: true }});
                            } else {
                                dispatch({ type: 'GET_ALLIES', payload: { data: data, first: first, last: last, next: false }});
                            }
                        });
                    }
                })
                .catch(error => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        }
    }

    const getAlliesExcel = () => {
        dispatch({ type: 'GET_ALLIES_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAlliesExcel();
        } else {
            getAlliesPerCountryExcel(authenticatedState.user.pais);
        }
    }

    const getGlobalAlliesExcel = () => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados")

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_ALLIES_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
            })
            .catch(error => dispatch({ type: 'GET_ALLIES_EXCEL_ERROR', payload: { code: 'allies/error', message: error } }))   
    };

    const getAlliesPerCountryExcel = (country) => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados")
            .where('pais', "==", country)

        first.get().then((documentSnapshots) => {
            dispatch({ type: 'GET_ALLIES_EXCEL', payload: { data: documentSnapshots.docs.map(doc => doc.data()) } });
        })
        .catch(error => dispatch({ type: 'GET_ALLIES_EXCEL_ERROR', payload: { code: 'allies/error', message: error } }))   
    }

    const getAlliesNotApproved = (page) => {
        dispatch({ type: 'GET_ALLIES_LOADING' });

        getAlliesNotApprovedPerCountry(authenticatedState.user.pais, page);
    };

    const getAlliesNotApprovedPerCountry = (country, page) => {
        let db = firestoreInitialize();

        db.collection('Aliados')
            .where('pais', '==', country)
            .get()
            .then((querySnapshot) => {
                let allies = querySnapshot.docs.map(doc => doc.data())
                let nextPage;
    
                allies = allies.filter(ally => typeof ally.isApproved === 'undefined');

                let nextAllies;

                if (page) {
                    if (page === '1') {
                        nextAllies = allies.slice(10, 11);
    
                        if (nextAllies.length === 1) {
                            nextAllies = true;
                        } else {
                            nextAllies = false;
                        }
    
                        allies = allies.slice(0, 10);
                    } else {
                        nextPage = `${page}0`;
    
                        nextAllies = allies.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);
    
                        if (nextAllies.length === 1) {
                            nextAllies = true;
                        } else {
                            nextAllies = false;
                        }
    
                        allies = allies.slice(parseInt(nextPage) - 10, parseInt(nextPage));
                    }
                } else {
                    nextAllies = false;
                }

                dispatch({ type: 'GET_ALLIES', payload: { data: allies, first: querySnapshot.docs[querySnapshot.docs.length=0], last: querySnapshot.docs[querySnapshot.docs.length-1], next: nextAllies} });
            })
            .catch((error) => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))
    }

    const getAlliesById = (id) => {
        dispatch({ type: 'GET_ALLIES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_ALLIES_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_ALLIES_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_ALLIES_BY_ID', payload: { code: 'allies/allies-error', message: error } })
        });
    };

    const getAlliesByName = (query) => {
        dispatch({ type: 'GET_ALLIES_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAlliesByName(query);
        } else {
            getAlliesByNameCountry(query, authenticatedState.user.pais);
        }
    };

    const getGlobalAlliesByName = (query) => {
        let db = firestoreInitialize();

        db.collection('Aliados')
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].nombre && data[i].nombre.toLowerCase().includes(query.toLowerCase())) || (data[i].nombreComercial && data[i].nombreComercial.toLowerCase().includes(query.toLowerCase())) || (data[i].tipoAliado && data[i].tipoAliado.toLowerCase().includes(query.toLowerCase())) || (data[i].telefono && data[i].telefono.toLowerCase().includes(query.toLowerCase())) || (data[i].email && data[i].email.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_ALLIES', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))
    }

    const getAlliesByNameCountry = (query, country) => {
        let db = firestoreInitialize();

        db.collection('Aliados')
        .where('pais', '==', country)
        .get()
        .then((documentSnapshots) => {
            const data = documentSnapshots.docs.map(doc => doc.data());
            let results = [];

            for (let i = 0; i < data.length; i++) {
                if ((data[i].nombre && data[i].nombre.toLowerCase().includes(query.toLowerCase())) || (data[i].nombreComercial && data[i].nombreComercial.toLowerCase().includes(query.toLowerCase())) || (data[i].tipoAliado && data[i].tipoAliado.toLowerCase().includes(query.toLowerCase())) || (data[i].telefono && data[i].telefono.toLowerCase().includes(query.toLowerCase())) || (data[i].email && data[i].email.toLowerCase().includes(query.toLowerCase()))) {
                    results.push(data[i]);
                }
            }

            dispatch({ type: 'GET_ALLIES', payload: { data: results, first: null, last: null, next: false }});
        })
        .catch((error) => dispatch({ type: 'GET_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))
    }

    const getAlliesPerMonth = async (startActualDate, endActualDate, startPreviusDate, endPreviusDate) => {
        dispatch({ type: 'GET_ALLIES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let alliesActualMonth;
        let alliesPreviusMonth;

        let convertActualDate = new Date(startActualDate).getTime();
        convertActualDate = convertActualDate + 86400000;
        convertActualDate = new Date(convertActualDate).setHours(0);

        let convertDate = new Date(convertActualDate);
        let startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
        let endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
        endDate = endDate.setHours(23,59,59,999)

        await db.collection('Aliados')
        .where('fechaCierre', '>=', new Date(startDate))
        .where('fechaCierre', '<=', new Date(endDate))
        .get()
        .then((documentSnapshots) => {
            alliesActualMonth = documentSnapshots.docs.map(doc => doc.data())
        })

        if (startPreviusDate !== 0 && endPreviusDate !== 0) {
            let convertActualStartDate = new Date(startPreviusDate).getTime();
            convertActualStartDate = convertActualStartDate + 86400000;
            convertActualStartDate = new Date(convertActualStartDate).setHours(0);

            let convertDate = new Date(convertActualStartDate);
            let startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
            let endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            endDate = endDate.setHours(23,59,59,999)
            
            await db.collection('Aliados')
            .where('fechaCierre', '>=', new Date(startDate))
            .where('fechaCierre', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                alliesPreviusMonth = documentSnapshots.docs.map(doc => doc.data())
            })

            dispatch({ type: 'GET_ALLIES_BY_ID', payload: { alliesActualMonth: alliesActualMonth, alliesPreviusMonth: alliesPreviusMonth } })
        } else {
            dispatch({ type: 'GET_ALLIES_BY_ID', payload: { alliesActualMonth: alliesActualMonth, alliesPreviusMonth: [] } })
        }
    };

    const updateAlliesById = (id, data) => {
        dispatch({ type: 'UPDATE_ALLIES_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        let date = firebase.firestore.FieldValue.serverTimestamp();

        docRef.update({
            isApproved: data.isApproved,
            status: data.status,
            usuarioAtendio: data.userAttends,
            fechaCierre: date,
            nombreOdoo: data.odooName,
            comentario: data.commentary
        })
        .then(() => {
            dispatch({ type: 'UPDATE_ALLIES_BY_ID', payload: { 
                newIsApproved: data.isApproved,
                newStatus: data.status,
                newUserAttends: data.userAttends,
                newOdooName: data.odooName,
                newCommentary: data.commentary
            }});
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_ALLIES_BY_ID_ERROR', payload: { code: 'ally/update-error', message: error } });
        });
    };

    const updateVerifyAlly = (id) => {
        dispatch({ type: 'VERIFY_ALLY_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        docRef.update({
            status: false,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_ALLY_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_ALLY_BY_ID_ERROR', payload: { code: 'verify-ally/update-error', message: error } });
        });
    };
    

    const updateApprovedAlly = (id, isApproved) => {
        dispatch({ type: 'VERIFY_ALLY_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        docRef.update({
            isApproved: isApproved,
        })
        .then(() => {
            dispatch({ type: 'VERIFY_ALLY_BY_ID' });
        })
        .catch((error) => {
            dispatch({ type: 'VERIFY_ALLY_BY_ID_ERROR', payload: { code: 'verify-ally/update-error', message: error } });
        });
    };

    const resetVerifyAlly = () => {
        dispatch({ type: 'VERIFY_ALLY_BY_ID_RESET_STATE' });
    };

    const getAlliesFilter = (status, type, country, page) => {
        dispatch({ type: 'GET_ALLIES_FILTER_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAlliesFilter(status, type, country, page);
        } else {
            getAlliesFilterPerCountry(status, type, page, authenticatedState.user.pais);
        }
    }

    const getGlobalAlliesFilter = (status, type, country, page) => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados")

        first.get().then((documentSnapshots) => {
            let allies = documentSnapshots.docs.map(doc => doc.data())
            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    allies = allies.filter(ally => ally.isApproved === true);
                } else if (status === 'Negado') {
                    allies = allies.filter(ally => ally.isApproved === false && ally.fechaCierre);
                } else {
                    allies = allies.filter(ally => typeof ally.isApproved === 'undefined');
                }
            }

            if (type) {
                allies = allies.filter(ally => ally.tipoAliado === type)
            }

            if (country) {
                allies = allies.filter(ally => ally.pais === country)
            }

            let nextAllies;

            if (page === '1') {
                nextAllies = allies.slice(10, 11);

                if (nextAllies.length === 1) {
                    nextAllies = true;
                } else {
                    nextAllies = false;
                }

                allies = allies.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextAllies = allies.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextAllies.length === 1) {
                    nextAllies = true;
                } else {
                    nextAllies = false;
                }

                allies = allies.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_ALLIES_FILTER', payload: { data: allies, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextAllies } })
        })
        .catch(error => dispatch({ type: 'GET_ALLIES_FILTER_ERROR', payload: { code: 'allies/error', message: error } }))     
    }

    const getAlliesFilterPerCountry = (status, type, page, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados").where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];
            let nextPage;
    
            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }  

                if (type) {
                    newData = newData.filter(ally => ally.tipoAliado === type)
                }
            } else {
                if (type) {
                    newData = dataFetch.filter(ally => ally.tipoAliado === type)
                }
            }

            let nextAllies;

            if (page === '1') {
                nextAllies = newData.slice(10, 11);

                if (nextAllies.length === 1) {
                    nextAllies = true;
                } else {
                    nextAllies = false;
                }

                newData = newData.slice(0, 10);
            } else {
                nextPage = `${page}0`;

                nextAllies = newData.slice((parseInt(nextPage) - 10) + 10, parseInt(nextPage) + 1);

                if (nextAllies.length === 1) {
                    nextAllies = true;
                } else {
                    nextAllies = false;
                }

                newData = newData.slice(parseInt(nextPage) - 10, parseInt(nextPage));
            }

            dispatch({ type: 'GET_ALLIES_FILTER', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1], next: nextAllies } })
        })
        .catch(error => dispatch({ type: 'GET_ALLIES_FILTER_ERROR', payload: { code: 'allies/error', message: error } }))     
    }

    const getAlliesFilterExcel = (status, type, country) => {
        dispatch({ type: 'GET_ALLIES_FILTER_EXCEL_LOADING' });

        if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAlliesFilterExcel(status, type, country);
        } else {
            getAlliesFilterPerCountryExcel(status, type, authenticatedState.user.pais);
        }
    }

    const getGlobalAlliesFilterExcel = (status, type, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados")

        first.get().then((documentSnapshots) => {
            let allies = documentSnapshots.docs.map(doc => doc.data())
    
            if (status) {
                if (status === 'Registrada') {
                    allies = allies.filter(ally => ally.isApproved === true);
                } else if (status === 'Negado') {
                    allies = allies.filter(ally => ally.isApproved === false);
                } else {
                    allies = allies.filter(ally => typeof ally.isApproved === 'undefined');
                }

                if (type) {
                    allies = allies.filter(dataType => dataType.tipoAliado === type)
                }
            } else {
                allies = allies.filter(dataFetch => dataFetch.tipoAliado === type);
            }

            if (type) {
                allies = allies.filter(ally => ally.tipoAliado === type)
            }

            if (country) {
                allies = allies.filter(ally => ally.pais === country)
            }

            dispatch({ type: 'GET_ALLIES_FILTER_EXCEL', payload: { data: allies, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_ALLIES_FILTER_EXCEL_ERROR', payload: { code: 'allies/error', message: error } }))     
    }

    const getAlliesFilterPerCountryExcel = (status, type, country) => {
        let db = firestoreInitialize();

        let first = db.collection("Aliados").where("pais", "==", country)

        first.get().then((documentSnapshots) => {
            const dataFetch = documentSnapshots.docs.map(doc => doc.data())

            let newData = [];

            if (status) {
                if (status === 'Registrada') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === true);
                } else if (status === 'Negado') {
                    newData = dataFetch.filter(dataFetch => dataFetch.isApproved === false);
                } else {
                    newData = dataFetch.filter(dataFetch => typeof dataFetch.isApproved === 'undefined');
                }

                if (type) {
                    newData = newData.filter(dataType => dataType.tipoAliado === type)
                }
            } else {
                newData = dataFetch.filter(dataFetch => dataFetch.tipoAliado === type);
            }

            dispatch({ type: 'GET_ALLIES_FILTER_EXCEL', payload: { data: newData, first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1] } })
        })
        .catch(error => dispatch({ type: 'GET_ALLIES_FILTER_EXCEL_ERROR', payload: { code: 'allies/error', message: error } }))     
    }

    const getTypesAllies = (nextPage, prevPage, notPagination) => {
        dispatch({ type: 'GET_TYPES_ALLIES_LOADING' });

        let db = firestoreInitialize();

        if (notPagination) {
            db.collection('TipoAliado')
            .get()
            .then((documentSnapshots) => {
                dispatch({ type: 'GET_TYPES_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.id), first: null, last: null } });
            })
            .catch(error => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } })) 
        } else if (nextPage) {
            db.collection('TipoAliado')
            .doc(nextPage)
            .get()
            .then((querySnapshot) => {
                let first = db.collection("TipoAliado")
                .startAfter(querySnapshot)
                .limit(10)

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_TYPES_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.id), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))
        } else if (prevPage) {
            db.collection('TipoAliado')
            .doc(prevPage)
            .get()
            .then((querySnapshot) => {
                let first = db.collection("TipoAliado")
                .endBefore(querySnapshot)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_TYPES_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.id), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))
        } else {
            let first = db.collection("TipoAliado")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_TYPES_ALLIES', payload: { data: documentSnapshots.docs.map(doc => doc.id), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_TYPES_ALLIES_ERROR', payload: { code: 'allies/error', message: error } }))   
        }
    };

    const getAlliesAllMonth = async (country) => {
        dispatch({ type: 'GET_ALLIES_ALL_MONTH_LOADING' });

        if (country) {
            getAlliesAllMonthPerCountry(country);
        } else if (!authenticatedState.user.pais || authenticatedState.user.role === "Administrador" || authenticatedState.user.role === "Operador") {
            getGlobalAlliesAllMonth();
        } else {
            getAlliesAllMonthPerCountry(authenticatedState.user.pais);
        }
    };

    const getGlobalAlliesAllMonth = async () => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let alliesPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Aliados')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                alliesPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_ALLIES_ALL_MONTH', payload: { data: alliesPerMonth } });
    }

    const getAlliesAllMonthPerCountry = async (country) => {
        const year = new Date().getFullYear()

        let db = firestoreInitialize();

        let alliesPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Aliados')
            .where('createdOn', '>=', new Date(startDate))
            .where('createdOn', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                let data = documentSnapshots.docs.map(doc => doc.data());
                data = data.filter(data => data.pais === country);
                
                alliesPerMonth.push(data);
            })
        }

        dispatch({ type: 'GET_ALLIES_ALL_MONTH', payload: { data: alliesPerMonth } });
    }

    const createAlliesType = (type) => {
        dispatch({ type: 'CREATE_TYPES_ALLIES_LOADING' });

        let db = firestoreInitialize();

        db.collection('TipoAliado').doc(type).set({})
            .then(() => dispatch({ type: 'CREATE_TYPES_ALLIES' }))
            .catch(() => dispatch({ type: 'CREATE_TYPES_ALLIES_ERROR' }));
    };

    const deleteAlliesType = (type, alliesTypes) => {
        dispatch({ type: 'DELETE_TYPES_ALLIES_LOADING' });

        const newAlliesTypes = alliesTypes.filter(allyType => allyType !== type);

        let db = firestoreInitialize();

        db.collection('TipoAliado').doc(type).delete()
            .then(() => dispatch({ type: 'DELETE_TYPES_ALLIES', payload: newAlliesTypes }))
            .catch(() => dispatch({ type: 'DELETE_TYPES_ALLIES_ERROR' }));
        
    }

    const deleteAlliesTypeResetState = () => {
        dispatch({ type: 'DELETE_TYPES_ALLIES_RESET_STATE' });
    }

    const updateCommissionsMarketPlaceAlly = (id, commissionList) => {
        dispatch({ type: 'UPDATE_COMMISSIONS_ALLY_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        docRef.update({
            acuerdosComisionMarketPlace: commissionList,
        })
        .then(() => {
            dispatch({ type: 'UPDATE_COMMISSIONS_ALLY' });
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_COMMISSIONS_ALLY_ERROR', payload: { code: 'commission-ally/update-error', message: error } });
        });
    };

    const updateCommissionsReferralsAlly = (id, commissionList) => {
        dispatch({ type: 'UPDATE_COMMISSIONS_ALLY_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Aliados").doc(id);

        docRef.update({
            acuerdosComisionReferidos: commissionList,
        })
        .then(() => {
            dispatch({ type: 'UPDATE_COMMISSIONS_ALLY' });
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_COMMISSIONS_ALLY_ERROR', payload: { code: 'commission-ally/update-error', message: error } });
        });
    };

    const resetUpdateCommissionsAllyState = () => {
        dispatch({ type: 'UPDATE_COMMISSIONS_ALLY_RESET_STATE' });
    };

    const resetGetAlliesState = () => {
        dispatch({ type: 'GET_ALLIES_RESET_STATE' });
    };

    const resetAlliesState = () => {
        dispatch({ type: 'ALLIES_RESET_STATE' });
    };

    const resetAlliesExcelState = () => {
        dispatch({ type: 'ALLIES_EXCEL_RESET_STATE' });
    };

    return (
        <AlliesContext.Provider value={{
            alliesState: state.getAllies,
            alliesAllMonthState: state.getAlliesAllMonth,
            alliesByIdState: state.getAlliesById,
            alliesUpdateState: state.updateAlliesById,
            typesAlliesState: state.getTypesAllies,
            createAlliesTypesState: state.createAlliesTypes,
            deleteAlliesTypeState: state.deleteAlliesTypes,
            verifyAllyState: state.verifyAlly,
            updateCommissionsAllyState: state.updateCommissionsAlly,
            alliesExcelState: state.getAlliesExcel,
            getAllies,
            getAlliesExcel,
            getAlliesFilterExcel,
            getAlliesNotApproved,
            getAlliesById,
            getAlliesByName,
            getAlliesPerMonth,
            updateAlliesById,
            updateVerifyAlly,
            updateApprovedAlly,
            getAlliesFilter,
            getTypesAllies,
            getAlliesAllMonth,
            createAlliesType,
            deleteAlliesType,
            updateCommissionsMarketPlaceAlly,
            updateCommissionsReferralsAlly,
            resetUpdateCommissionsAllyState,
            deleteAlliesTypeResetState,
            resetAlliesState,
            resetAlliesExcelState,
            resetGetAlliesState,
            resetVerifyAlly,
        }}>
            {props.children}
        </AlliesContext.Provider>
    )
}

export default AlliesState;
